import { render, staticRenderFns } from "./DetailsImagePreview.vue?vue&type=template&id=8258715a&scoped=true"
import script from "./DetailsImagePreview.vue?vue&type=script&lang=ts"
export * from "./DetailsImagePreview.vue?vue&type=script&lang=ts"
import style0 from "./DetailsImagePreview.vue?vue&type=style&index=0&id=8258715a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8258715a",
  null
  
)

export default component.exports